
const m = window.require("@ember-data/store");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
